module.exports = __webpack_public_path__ + "1e7fccc54e04df0151dc7a53ac2b0a4a.svg";